import { useState } from "react";
import { sendContactMessage } from "../services/api";
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await sendContactMessage(form);
      setSuccess(true);
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative py-32 bg-slate-50 overflow-hidden">

      {/* Subtle Atmosphere */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-blue-100/40 blur-3xl"></div>

      <div className="relative max-w-6xl mx-auto px-6 md:px-12">

        <div className="grid md:grid-cols-2 gap-16 bg-white border border-slate-200 rounded-2xl p-12 shadow-sm">

          {/* LEFT — FORM */}
          <div>
            <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900 mb-8">
              Contact Me
            </h1>

            <form onSubmit={handleSubmit} className="space-y-6">

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500/40 focus:ring-2 focus:ring-blue-100 transition"
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500/40 focus:ring-2 focus:ring-blue-100 transition"
              />

              <textarea
                name="message"
                placeholder="Your Message"
                value={form.message}
                onChange={handleChange}
                required
                rows="5"
                className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500/40 focus:ring-2 focus:ring-blue-100 transition"
              />

              <button
                type="submit"
                disabled={loading}
                className="
                  w-full
                  bg-blue-600
                  hover:bg-blue-700
                  text-white
                  py-3
                  rounded-full
                  font-medium
                  transition duration-300
                  hover:-translate-y-1
                  hover:shadow-xl
                  hover:shadow-blue-500/20
                "
              >
                {loading ? "Sending..." : "Send Message"}
              </button>

              {success && (
                <div className="mt-4 p-4 bg-blue-50 text-blue-700 rounded-xl border border-blue-200">
                  Message sent successfully.
                </div>
              )}

              {error && (
                <div className="mt-4 p-4 bg-red-50 text-red-600 rounded-xl border border-red-200">
                  {error}
                </div>
              )}
            </form>
          </div>

          {/* RIGHT — INFO */}
          <div className="flex flex-col justify-center space-y-8">

            <div>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                Let’s Connect
              </h2>

              <p className="text-slate-600 leading-relaxed">
                Open to discussing backend systems, performance optimization,
                or scalable architecture projects.
              </p>
            </div>

            <div className="space-y-3 text-slate-600">
              <a href="tel:+254758799912" className="block hover:text-blue-600 transition">
                +254 758 799 912
              </a>

              <a href="mailto:ptrmagaga@gmail.com" className="block hover:text-blue-600 transition">
                ptrmagaga@gmail.com
              </a>
            </div>

            <div className="flex gap-4 pt-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-4 rounded-full border border-slate-200 bg-white hover:bg-blue-600 hover:text-white hover:border-blue-600 transition duration-300"
              >
                <FaLinkedin size={20} />
              </a>

              <a
                href="https://wa.me/254758799912"
                target="_blank"
                rel="noopener noreferrer"
                className="p-4 rounded-full border border-slate-200 bg-white hover:bg-blue-600 hover:text-white hover:border-blue-600 transition duration-300"
              >
                <FaWhatsapp size={20} />
              </a>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}